
<template>
    <Map />
</template>

<script>
import Map from './components/Map.vue'

export default {
    name: "App",
    components: {
        Map,
    },
    data() {
        return {};
    },
};
</script>

<style scoped>

</style>
